import { VueModule } from '@Foundation/utilities';
import ExpandableContentCard from './code/Scripts/components/expandable-content-card.vue';

export default VueModule({
  components: {
    ExpandableContentCard
  }
});
